import { createAction, props } from "@ngrx/store";
import { Cost, Room } from "../types/room";

export const addRoom = createAction(
    '[Valuation Process Page - V2 / Valuation Tab] Add room',
    props<{}>()
)

export const removeRoom = createAction(
    '[Valuation Process Page - V2 / Valuation Tab] Remove room',
    props<{id: number | string}>()
)

export const updateState = createAction(
    '[Valuation Process Page - V2 / Valuation Tab] Update hotel state',
    props<{
        rooms: Room[],
        costs: Cost[],
        foodBeverageRevenue: number | null,
        otherRevenue: number | null,
        capitalRate: number | null,
        purchaserCost: number | null,
        opex: number | null,
        fbCost: number | null,
        opexChoiceId: number | null,
        fbChoiceId: number | null,
        timingId: number | null
    }>()
)

export const addCost = createAction(
    '[Valuation Process Page - V2 / Valuation Tab] add cost',
    props<{}>()
)

export const removeCost = createAction(
    '[Valuation Process Page - V2 / Valuation Tab] remove cost',
    props<{id: number | string}>()
)